export default __webpack_public_path__ + "assets/e8af303817d94c2e2a2edd88eed3cb7c.jpg";